import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/logo_myculture.png'
import _imports_1 from '@/assets/icons/upload_24px.png'


const _withScopeId = n => (_pushScopeId("data-v-44b4276c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "create_email",
  class: "body flex-mid"
}
const _hoisted_2 = { class: "card create-account look-and-feel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Happily logo",
  style: {"margin-bottom":"4.4rem","width":"18rem"}
}, null, -1))
const _hoisted_4 = { class: "fw-900 fs-18" }
const _hoisted_5 = {
  class: "grid-2",
  style: {"margin-top":"4.4rem"}
}
const _hoisted_6 = { class: "image relative" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "absolute-mid"
}
const _hoisted_9 = {
  key: 1,
  class: "absolute-mid events-none"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "icons_upload_24px"
  })
], -1))
const _hoisted_11 = { class: "fs-15 fw-700 opa-06 mt-4" }
const _hoisted_12 = {
  class: "input-44-0000000d no-icon validate-false flex-center",
  style: {"padding-left":"3rem","width":"calc(100% - 4.6rem)"}
}
const _hoisted_13 = { class: "color-pick mt-16" }
const _hoisted_14 = {
  class: "grid-2-btn",
  style: {"margin-top":"8.8rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_loading = _resolveComponent("loading")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("createAccount.Give_your_assessments")), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_upload, {
            class: "avatar-uploader",
            "show-file-list": false,
            "http-request": _ctx.handleAvatarSuccess,
            "before-upload": _ctx.beforeAvatarUpload
          }, {
            default: _withCtx(() => [
              (_ctx.form.imageFile)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.form.imageFile,
                    class: "avatar"
                  }, null, 8, _hoisted_7))
                : (_openBlock(), _createBlock(_component_el_icon, {
                    key: 1,
                    class: "avatar-uploader-icon"
                  }))
            ]),
            _: 1
          }, 8, ["http-request", "before-upload"]),
          (_ctx.loadingImageFile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_loading)
              ]))
            : (!_ctx.form.imageFile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("createAccount.Upload_Logo")), 1)
                ]))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.form.color), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_color_picker, {
              modelValue: _ctx.form.color,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.color) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitFrom())),
          class: "btn-skip flex-mid mt-32"
        }, _toDisplayString(_ctx.$t("btn.Do_it_later")), 1),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitFrom())),
          class: "btn-create btn-primary flex-mid mt-32"
        }, _toDisplayString(_ctx.$t("createAccount.Finish_sign_up")), 1)
      ])
    ])
  ]))
}